import { render, staticRenderFns } from "./editAccount.vue?vue&type=template&id=436b30fa&scoped=true"
import script from "./editAccount.vue?vue&type=script&lang=js"
export * from "./editAccount.vue?vue&type=script&lang=js"
import style0 from "./editAccount.vue?vue&type=style&index=0&id=436b30fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "436b30fa",
  null
  
)

export default component.exports